import PropTypes from 'prop-types';
import React from 'react';

import './style.css';

const sleep = (ms: any) => new Promise((resolve) => setTimeout(resolve, ms));
const pixelsStep = 7;

const Slider = (props: any) => {
  const { width, children } = props;

  const containerWrapper: any = React.useRef();
  const containerSlider: any = React.useRef();

  const [showLeft, setShowLeft] = React.useState(false);
  const [showRight, setShowRight] = React.useState(false);
  const [showButtons, setShowButtons] = React.useState(false);

  const scrollContainerHandler = React.useCallback(() => {
    if (!containerWrapper.current) {
      return;
    }
    const { scrollLeft, scrollWidth, offsetWidth } = containerWrapper.current;

    const newShowLeft = scrollLeft >= 1;
    if (newShowLeft !== showLeft) {
      setShowLeft(newShowLeft);
    }

    const newShowRight = scrollWidth - scrollLeft - offsetWidth >= 2;
    if (newShowRight !== showRight) {
      setShowRight(newShowRight);
    }
  }, [containerWrapper, showLeft, showRight]);

  React.useLayoutEffect(() => {
    if (!containerWrapper.current) {
      return;
    }

    const containerWrapperCurrent: any = containerWrapper.current;
    containerWrapperCurrent.addEventListener('scroll', scrollContainerHandler, true);

    scrollContainerHandler();

    return () => {
      if (!containerWrapperCurrent) {
        return;
      }
      containerWrapperCurrent.removeEventListener('scroll', scrollContainerHandler, true);
    };
  }, [scrollContainerHandler, containerWrapper]);

  React.useLayoutEffect(() => {
    if (!containerWrapper.current) {
      return;
    }

    setShowButtons(containerSlider.current?.offsetWidth + 1 < containerWrapper.current.scrollWidth);
    scrollContainerHandler();
  }, [children, scrollContainerHandler, containerWrapper]);

  const scroller = async (direction: number) => {
    for (let i = 0; i <= 25; i++) {
      await sleep(10); // eslint-disable-line no-await-in-loop
      containerWrapper.current.scrollLeft -= direction;
    }
  };

  return (
    <div
      className={`filter-slider ${showButtons ? 'slider-with-buttons' : ''}`}
      ref={containerSlider}
      style={{
        maxWidth: `calc(100vw - ${width}px)`,
      }}
    >
      {showButtons && (
        <div className="filter-slider-buttons action-buttons">
          <button
            type="button"
            className="btn btn-sm btn-box-tool options-menu-btn"
            disabled={!showLeft}
            onClick={() => scroller(pixelsStep)}
          >
            <i className="lnr lnr-arrow-left-circle" />
          </button>

          <button
            type="button"
            className="btn btn-sm btn-box-tool options-menu-btn"
            disabled={!showRight}
            onClick={() => scroller(-pixelsStep)}
          >
            <i className="lnr lnr-arrow-right-circle" />
          </button>
        </div>
      )}

      <div ref={containerWrapper} className="filter-slide-wrapper">
        {children}
      </div>
    </div>
  );
};

Slider.propTypes = {
  width: PropTypes.number.isRequired,
  children: PropTypes.object.isRequired,
};

// eslint-disable-next-line import/no-default-export
export default Slider;
